// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2DuNx","title":"Images45_title__1g5m1","images":"Images45_images__2D2Wf"};